import { createReducer } from '../../../store.model';

import { FilterSummary } from './state/filter-summary.action';
import { filterSummaryReducer } from './state/filter-summary.reducer';
import { Load, LoadResult } from './state/load.action';
import { loadReducer, loadResultReducer } from './state/load.reducer';
import { ActionType } from './teamschat-summary.action';
import { defaultState, TeamschatSummaryState } from './teamschat-summary.state';

const { builder, reducer } = createReducer<ActionType, TeamschatSummaryState>(
    defaultState(),
);

builder.add<Load>(ActionType.TEAMS_CALL__TCS__LOAD, loadReducer);
builder.add<LoadResult>(
    ActionType.TEAMS_CALL__TCS__LOAD_RESULT,
    loadResultReducer,
);

builder.add<FilterSummary>(
    ActionType.TEAMS_CALL__TCS__FILTER_SUMMARY,
    filterSummaryReducer,
);

export const teamschatSummaryReducer = reducer;
